import { redirect } from './redirect'
import config from '../../config'

const { REACT_APP_BFF_ACCOUNTS_URL, REACT_APP_ACCOUNTS_APP_URL } = config

// redirectUrl is the location to redirect to once the user has been effectively logged out.
const logout = (
  redirectUrl = `${REACT_APP_ACCOUNTS_APP_URL}/login`
)=> {
  const logoutUrl = `${REACT_APP_BFF_ACCOUNTS_URL}/auth/logout?redirect=${encodeURIComponent(
    redirectUrl
  )}`
  redirect(logoutUrl)
}

export default logout



// WEBPACK FOOTER //
// ./src/shared/utils/logout.js